module.exports = "/images/vendor/desiigner-svg/svg/logos/best-in-travel-2021-horizontal.svg?b1e846fce2725eeb9d30369563be50d0";